module.exports = __webpack_public_path__ + "static/media/avatar-staff-default.47922723.png";